(function($, undefined) {

	'use strict';
	var tab;

	var openVideoPopup = function() {
		var t = $(this);
		var id = t.attr('data-id');
		var popup = $('.com-video-popup[data-id=' + id + ']');

		popup.find('iframe').attr('src', popup.find('iframe').attr('data-url') + '?autoplay=1');
		popup.addClass('visible');
	};

	var closeVideoPopup = function() {
		var t = $(this);
		var popup = t.closest('.com-video-popup');

		popup.find('iframe').attr('src', popup.find('iframe').attr('data-url'));
		popup.removeClass('visible');
	};

	var init = function() {
		$('.com-video-open-video-btn').click(openVideoPopup);
		$('.close-com-video-popup-btn').click(closeVideoPopup);
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

